export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref14039.bb07a352.jpg";